<template>
  <div id="analysesManagment">
    <u-loader v-if="isLoading" />
    <div
      v-if="!isLoading"
      class="form-group mb-4"
    >
      <b-container class="pb-0 pt-0">
        <b-row
          v-if="errorMessages"
          class="mt-4"
        >
          <div class="col-12 pl-0">
            <b-alert
              show
              variant="danger"
            >
              {{ errorMessages }}
            </b-alert>
          </div>
        </b-row>
        <b-row class="mt-4">
          <label class="pl-0 col-1 defaultLabel">
            tempdata-ApiKey-Verwendungen
          </label>
          <div class="col-4 pl-0">
            <u-date-picker
              v-model="apiKeysdateFrom"
              label="Von:"
              prepend-icon="mdi-calendar"
            />
          </div>

          <div class="col-4 pl-0">
            <u-date-picker
              v-model="apiKeysdateTo"
              label="Bis:"
              prepend-icon="mdi-calendar"
            />
          </div>
          <div class="col-2 pl-0">
            <v-btn
              color="#f44336"
              class="ma-2 white--text"
              @click="exportTempdataKexUsageAnalyses()"
            >
              Auswertung exportieren
              <i class="fas fa-download pl-2" />
            </v-btn>
          </div>
        </b-row>
        <v-divider />
        <b-row class="mt-4">
          <label class="pl-0 col-1 defaultLabel"> Log-Auswertung </label>
          <div class="col-4 pl-0">
            <u-date-picker
              v-model="gavServiceDateFrom"
              label="Von:"
              prepend-icon="mdi-calendar"
            />
          </div>

          <div class="col-4 pl-0">
            <u-date-picker
              v-model="gavServiceDateTo"
              label="Bis:"
              prepend-icon="mdi-calendar"
            />
          </div>
          <div class="col-2 pl-0">
            <v-btn
              color="#f44336"
              class="ma-2 white--text"
              @click="exportFullUsageOverviewAnalyses()"
            >
              Auswertung exportieren
              <i class="fas fa-download pl-2" />
            </v-btn>
          </div>
        </b-row>
        <v-divider />
        <b-row class="mt-4">
          <label class="pl-0 col-1 defaultLabel"> Job-Titel-Auswertung </label>
          <div class="col-4 pl-0">
            <u-date-picker
              v-model="jobTitleDateFrom"
              label="Von:"
              prepend-icon="mdi-calendar"
            />
          </div>

          <div class="col-4 pl-0">
            <u-date-picker
              v-model="jobTitleDateTo"
              label="Bis:"
              prepend-icon="mdi-calendar"
            />
          </div>
          <div class="col-2 pl-0">
            <v-btn
              color="#f44336"
              class="ma-2 white--text"
              @click="exportJobTitleOverviewAnalyses()"
            >
              Auswertung exportieren
              <i class="fas fa-download pl-2" />
            </v-btn>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import {
  GetTempDataApiKeyUsage,
  GetFullUsageOverviewAnalyses,
  GetJobTitleUsageOverviewAnalyses,
} from "@/services/analyses.service.js";
import UDatePicker from "@/components/common/UDatePicker.vue";
export default {
  components: {
    UDatePicker,
  },
  data() {
    return {
      apiKeysdateFrom: new Date().toISOString().substr(0, 10),
      apiKeysdateTo: new Date().toISOString().substr(0, 10),
      gavServiceDateFrom: new Date().toISOString().substr(0, 10),
      gavServiceDateTo: new Date().toISOString().substr(0, 10),
      jobTitleDateFrom: new Date().toISOString().substr(0, 10),
      jobTitleDateTo: new Date().toISOString().substr(0, 10),
      errorMessages: null,
      isLoading: false,
    };
  },
  methods: {
    exportTempdataKexUsageAnalyses() {
      this.isLoading = true;
      this.errorMessages = "";

      if (this.apiKeysdateFrom && this.apiKeysdateTo) {
        GetTempDataApiKeyUsage(
          this.apiKeysdateFrom,
          this.apiKeysdateTo,
          (result) => {
            if (result) {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${
                result.fileBase64String
              }`;
              const downloadLink = document.createElement("a");
              const fileName = result.filename;

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              this.isLoading = false;
            } else {
              this.errorMessages =
                "Es wurden keine Einträge zum angegeben Zeitraum gefunden. Wählen Sie bitte ein anderes Datum aus.";
              this.isLoading = false;
            }
          },
          (error) => {
            this.errorMessages = error;

            this.isLoading = false;
          },
        );
      } else {
        this.errorMessages = "Datum Von und Datum Bis muss angegeben werden!";
        this.isLoading = false;
      }
    },
    exportFullUsageOverviewAnalyses() {
      this.isLoading = true;
      this.errorMessages = "";

      if (this.gavServiceDateFrom && this.gavServiceDateTo) {
        GetFullUsageOverviewAnalyses(
          this.gavServiceDateFrom,
          this.gavServiceDateTo,
          (result) => {
            if (result) {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${
                result.fileBase64String
              }`;
              const downloadLink = document.createElement("a");
              const fileName = result.filename;

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              this.isLoading = false;
            } else {
              this.errorMessages =
                "Es wurden keine Einträge zum angegeben Zeitraum gefunden. Wählen Sie bitte ein anderes Datum aus.";
              this.isLoading = false;
            }
          },
          (error) => {
            this.errorMessages = error;

            this.isLoading = false;
          },
        );
      } else {
        this.errorMessages = "Datum Von und Datum Bis muss angegeben werden!";
        this.isLoading = false;
      }
    },
    exportJobTitleOverviewAnalyses() {
      this.isLoading = true;
      this.errorMessages = "";

      if (this.gavServiceDateFrom && this.gavServiceDateTo) {
        GetJobTitleUsageOverviewAnalyses(
          this.jobTitleDateFrom,
          this.jobTitleDateTo,
          (result) => {
            if (result) {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${
                result.fileBase64String
              }`;
              const downloadLink = document.createElement("a");
              const fileName = result.filename;

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              this.isLoading = false;
            } else {
              this.errorMessages =
                "Es wurden keine Einträge zum angegeben Zeitraum gefunden. Wählen Sie bitte ein anderes Datum aus.";
              this.isLoading = false;
            }
          },
          (error) => {
            this.errorMessages = error;

            this.isLoading = false;
          },
        );
      } else {
        this.errorMessages = "Datum Von und Datum Bis muss angegeben werden!";
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
